import { APP_INITIALIZER, NgModule, LOCALE_ID, isDevMode} from '@angular/core';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppLayoutModule } from './layout/app.layout.module';
import { TranslationService } from './layout/service/app.translation.service';
import { TenantService } from '@/app/plateformebeneficiaire/core/service/tenant.service';
import { TranslatePipe } from '@layout/pipes/translate.pipe';
import {
  provideTanStackQuery,
  QueryClient,
  withDevtools,
} from '@tanstack/angular-query-experimental'
import { MessageService } from 'primeng/api';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { ToastModule } from 'primeng/toast';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { CgvModalComponent } from './plateformebeneficiaire/components/cgv-modal/cgv-modal.component';
import { AppStateWrapperComponent } from './plateformebeneficiaire/components/app-state/app-state-wrapper.component';

registerLocaleData(localeFr);

function initializeAppFactory(
    translationService: TranslationService,
    tenantService: TenantService
  ): () => Promise<void> {
    return async () => {
      const lang = navigator.language.split('-')[0]; // Exemple : "en" ou "fr"
      const translations = await translationService.loadTranslations("fr").toPromise();
      translationService.setTranslations(translations);
    };
  }
  
@NgModule({
    imports: [
        AppLayoutModule,
        AppRoutingModule,
        TranslatePipe,
        ToastModule,
        CgvModalComponent,
        AppStateWrapperComponent,
        ServiceWorkerModule.register('ngsw-worker.js', {
          enabled: !isDevMode(),
          // Register the ServiceWorker as soon as the application is stable
          // or after 30 seconds (whichever comes first).
          registrationStrategy: 'registerWhenStable:30000'
        })
    ],
    declarations: [
        AppComponent,
    ],
    providers: [
        TranslationService,
        TenantService,
        MessageService,
        { provide: LOCALE_ID, useValue: 'fr' },
        // { 
        //     provide: LocationStrategy, 
        //     useClass: HashLocationStrategy,
        // },
        {
            provide: APP_INITIALIZER,
            useFactory: initializeAppFactory,
            deps: [TranslationService, TenantService],
            multi: true,
        },
        provideTanStackQuery(
          new QueryClient(), 
          withDevtools(() => ({ loadDevtools: !environment.hideTanstackDevtool })),)
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
